import styled from 'styled-components';
import { Card } from 'antd';

export const Container = styled(Card)`
  grid-area: lasNewsMisc;
  border-top: 4px solid #fd9226 !important;
  div.ant-card-body {
    div.ant-skeleton-header {
      padding: 0;
    }
    button {
      margin-top: 16px;
      color: #fd9226;
      border-color: #fd9226;
    }
  }
`;
export const Header = styled.div`
  display: flex;
  align-items: center;
  h4 {
    margin-right: auto;
  }
  img {
    height: 32px;
    width: 32px;
    margin-right: 16px;
  }
  svg {
    color: #fd9226;
    height: 32px;
    width: 32px;
  }
`;
